module.exports = __webpack_public_path__ + "media/images/emblems/Thierachern-coat_of_arms-60a356ca2aa8056beb2799c3073db18a.svg";